export const isFuneralHome = firm => {
  if (!firm) return false

  return firm && firm.get('firm-type') === 'funeral_home'
}

/**
 * Whether the firm's clients get the guided My Story / Life Story experience.
 * The API computes `my-story-enabled` (TK-3197): true for funeral home firms
 * and for non-FH firms whitelisted by ID in the my_story_enabled_firm_ids
 * Setting, so there is no client-side funeral home fallback here.
 */
export const hasMyStoryAccess = firm => Boolean(firm && firm.get('my-story-enabled'))

export const EVERPLANS_PROFESSIONAL = 'Everplans Professional'
export const EVERPLANS_FUNERAL_HOME = 'Everplans Funeral Home'

export const usesFuneralHomeBranding = ({isConcierge = false, firm} = {}) => (
  Boolean(isConcierge) || isFuneralHome(firm)
)

export const proBrandingResolved = ({sessionInitialized = false, currentUser, firm} = {}) => {
  if (!sessionInitialized) return false

  const user = currentUser || {}
  if (user.quarterback || !user.firm) return true

  return Boolean(firm && !firm.isEmpty())
}

export const proBrandName = funeralHomeBranding => (
  funeralHomeBranding ? EVERPLANS_FUNERAL_HOME : EVERPLANS_PROFESSIONAL
)

export const legacyClientInfo = (legacyClients, clientSeatId) => (
  legacyClients.find(legacyClient =>
    String(legacyClient.client_seat_id) === clientSeatId
  )
)
